import React, { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'
import { Flex, IFlex } from '@ads/front-ds'

export const OneColumnFlex: FC<PropsWithChildren<IFlex>> = ({
  children,
  ...props
}) => <Wrapper {...props}>{children}</Wrapper>

const Wrapper = styled(Flex)`
  width: 50%;
  flex-flow: column;
`
